export default "/img/truck-repair.png";